module.exports = __webpack_public_path__ + "img/edit-service.png";